module.exports = __webpack_public_path__ + "img/portraits_26_V.a4ffef23.webp";